import { cn } from "@/shared/utils/style.util";

const SkeletonLine = ({ className }: { className?: string }) => (
  <div className={cn("skeleton-base rounded", className)} />
);

export const SubsidySumupSkeleton = () => {
  return (
    <div className="space-y-4 animate-pulse">
      <SkeletonLine className="h-5 w-32" />

      <div className="space-y-3">
        <SkeletonLine className="h-4 w-40" />
        <div className="space-y-2 pl-2">
          <div className="flex items-center justify-between">
            <SkeletonLine className="h-3 w-36" />
            <SkeletonLine className="h-3 w-12" />
          </div>
          <div className="flex items-center justify-between">
            <SkeletonLine className="h-3 w-44" />
            <SkeletonLine className="h-3 w-12" />
          </div>
        </div>
      </div>

      <div className="space-y-3">
        <SkeletonLine className="h-4 w-36" />
        <div className="space-y-2 pl-2">
          <div className="flex items-center justify-between">
            <SkeletonLine className="h-3 w-40" />
            <SkeletonLine className="h-3 w-12" />
          </div>
          <div className="flex items-center justify-between">
            <SkeletonLine className="h-3 w-28" />
            <SkeletonLine className="h-3 w-14" />
          </div>
        </div>
      </div>
    </div>
  );
};
